import { put, select } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import {
  fetchTopicsForPinnedKnowledge,
  updateTopicPinnedKnowledgeFulfilled,
  updateTopicPinnedKnowledgeRejected,
} from "domains/pinAddReject/actions";
import type { UpdateTopicPinnedKnowledge } from "domains/pinAddReject/actionTypes";
import { getKnowledgeById } from "entities/knowledge/selectors";

export function* updateTopicPinnedKnowledgeSaga(action: UpdateTopicPinnedKnowledge) {
  const { topicId, knowledgeId, isPinned } = action.meta;

  try {
    yield apiFetch(`topic/${topicId}/knowledge/pin`, {
      method: "PATCH",
      body: {
        add: isPinned ? [] : [knowledgeId],
        remove: isPinned ? [knowledgeId] : [],
      },
    });

    const updatedKnowledge: ReturnType<ReturnType<typeof getKnowledgeById>> = yield select(
      getKnowledgeById(knowledgeId),
    );

    yield put(updateTopicPinnedKnowledgeFulfilled({ ...action.meta, isPinned: !isPinned }, { updatedKnowledge }));

    yield put(fetchTopicsForPinnedKnowledge({ knowledgeId }));
  } catch (error) {
    logger.error("[updateTopicPinnedKnowledgeSaga] Error occurred while updating pinned knowledge", error);
    yield put(updateTopicPinnedKnowledgeRejected({ ...action.meta, logoutOnAuthError: true }));
  }
}
